module.exports = __webpack_public_path__ + "assets/img/mecha-3265c045.png";